var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessMessageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    clipPath: "url(#clip0_2151_231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.6596 7.44101V8.00003C13.6589 9.31036 13.2346 10.5853 12.45 11.6348C11.6654 12.6843 10.5627 13.4521 9.3061 13.8236C8.04955 14.1951 6.70656 14.1505 5.47743 13.6964C4.24831 13.2423 3.1989 12.403 2.48572 11.3038C1.77254 10.2046 1.43379 8.90424 1.52001 7.59675C1.60622 6.28927 2.11278 5.04468 2.96412 4.0486C3.81547 3.05253 4.96599 2.35834 6.2441 2.06957C7.52221 1.78079 8.85943 1.91291 10.0563 2.44621M13.6596 3.13892L7.58323 9.22139L5.76031 7.39847",
    stroke: "currentColor",
    strokeWidth: 1.21528,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2151_231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5833,
    height: 14.5833,
    fill: "white",
    transform: "translate(0.291992 0.708496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMessageIcon);
export default __webpack_public_path__ + "static/media/success-message-icon.6036630fc241ec6b1ee603718b2f2b18.svg";
export { ForwardRef as ReactComponent };